export default "__VITE_ASSET__Bk6jK66Z__"